"use client";
import {
  number_input_default
} from "./chunk-KFVDTU5B.mjs";
import "./chunk-HVA7EZPG.mjs";
import {
  useNumberInput
} from "./chunk-F7Q7LBLV.mjs";
export {
  number_input_default as NumberInput,
  useNumberInput
};
